import { gql } from '@apollo/client';

export const GET_CARDEXISTS = gql`
  query cardExists($cardNumber: Long!) {
    cardExists(cardNumber: $cardNumber)
  }
`;

export const GET_SYSTEMSEARCH = gql`
  query systemSearch($searchField: String!) {
    systemSearch(searchField: $searchField) {
      cardholders {
        totalCount
        edges {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_LASTACTIVE = gql`
  query lastActivity {
    lastActivity {
      cardholders {
        cards {
          cardNumber
        }
        id
        firstName
        lastName
        active
        photo
        lastActivity
      }
    }
  }
`;

export const GET_CARDHOLDERSFIELDS = gql`
  query cardholderFieldConfig {
    cardholderFieldConfig {
      fieldRows {
        weight
        fields {
          id
          label
          weight
          type
          required
        }
      }
    }
  }
`;

export const GET_AVAILABLEFIELDS = gql`
  query availableCardholderFields {
    availableCardholderFields {
      cardholderFields {
        id
        label
        type
      }
    }
  }
`;

export const UPDATE_CARDHOLDERFIELDS = gql`
  mutation updateCardholderFieldConfig($input: CardholderFieldConfigInput!) {
    updateCardholderFieldConfig(input: $input) {
      fieldRows {
        weight
        fields {
          id
          label
          weight
          type
          required
        }
      }
    }
  }
`;

export const GET_CARDHOLDER = gql`
  query cardholder($cardholderId: Int!) {
    cardholder(cardholderId: $cardholderId) {
      id
      firstName
      lastName
      title
      middleInitial
      office
      employeeNumber
      workPhone
      mobilePhone
      address
      building
      room
      city
      province
      postalCode
      country
      company
      office
      assistant
      homePhone
      fax
      workPhone
      emailAddress
      pager
      mobilePhone
      dateOfBirth
      sex
      height
      weight
      hairColor
      eyeColor
      startDate
      endDate
      ssn
      credentials
      preferredName
      notes
      lostBadgeCount
      homeroomNumber
      schoolBusNumber
      schoolIdNumber
      grade
      emergencyContact
      contactPhoneNumber
      migrationId
      active
      photo
      cards {
        active
        cardNumber
        primary
        lastActivity
        accessGroups {
          id
          name
        }
        singleReaderAccessRights {
          engageReaders {
            id
            name
            type
          }
        }
        issueCode
        activationDate
        antipassbackExempt
        engageCardFormat
        siteCode
        engageIssueCode
        cardFunction
        deactivationDate
        freeAntipassback
        vacationStartDate
        vacationEndDate
        issueCode
        pin
        useAdaTiming
        useLimit
        doNotUpdateUseCount
      }
      mobileCredentials {
        id
        credentialNumber
        active
        phoneNumber
        useAdaTiming
        facilityCode
        issueCode
        activationDate
        deactivationDate
        cardFunction
        accessGroups {
          id
          name
        }
        singleReaderAccessRights {
          engageReaders {
            id
            name
            type
          }
        }
      }
      customFields {
        key
        value
      }
    }
  }
`;

export const GET_CARDHOLDERS = gql`
  query cardholders($first: Int!, $skip: Int!) {
    cardholders(first: $first, skip: $skip) {
      totalCount
      edges {
        id
        firstName
        lastName
        title
        photo
        employeeNumber
        lastActivity
      }
    }
  }
`;

export const GET_WIDGETS = gql`
  query widgetData {
    widgetData {
      widgets {
        WidgetID
        Bookmarked
        Height
        MaxHeight
        MaxWidth
        MinHeight
        MinWidth
        Moveable
        PhotoRecall {
          WidgetID
          Layout
          Configuration
          GridSize
          PhotoRecallID
          PhotoRecallSize
        }
        Resizeable
        WidgetType
        Width
        XPosition
        YPosition
      }
    }
  }
`;

export const GET_PRS = gql`
  query photoRecallData {
    photoRecallData {
      photoRecallWidgets {
        Configuration
        GridSize
        Layout
        PhotoRecallID
        WidgetID
        PhotoRecallSize
      }
    }
  }
`;

export const ADD_WIDGET = gql`
  mutation addWebWidget($widgetInput: WidgetInput) {
    addWebWidget(widgetInput: $widgetInput) {
      Bookmarked
      Height
      Width
      XPosition
      YPosition
      MaxHeight
      MaxWidth
      MinHeight
      MinWidth
      Moveable
      Resizeable
      WidgetType
      WidgetID
      PhotoRecall {
        WidgetID
        Configuration
      }
    }
  }
`;

export const REMOVE_WIDGET = gql`
  mutation removeWidget($widgetInputID: Long!) {
    removeWidget(widgetInputID: $widgetInputID) {
      WidgetID
    }
  }
`;

export const UPDATE_WIDGET = gql`
  mutation updateWidgets($widgetInput: WidgetInput, $widgetInputID: Long!) {
    updateWidgets(widgetInput: $widgetInput, widgetInputID: $widgetInputID) {
      WidgetID
      XPosition
      YPosition
      Height
    }
  }
`;

export const ADD_PR = gql`
  mutation addPhotoRecall($widgetInputID: Long!, $photoRecallInput: PhotoRecallInput) {
    addPhotoRecall(widgetInputID: $widgetInputID, photoRecallInput: $photoRecallInput) {
      WidgetID
      PhotoRecallID
      Configuration
      GridSize
      Layout
      PhotoRecallSize
    }
  }
`;

export const REMOVE_PR = gql`
  mutation removePRWidget($photoRecallID: Long!) {
    removePRWidget(photoRecallID: $photoRecallID) {
      PhotoRecallID
    }
  }
`;

export const UPDATE_PR = gql`
  mutation updatePhotoRecall($photoRecallID: Long!, $photoRecallInput: PhotoRecallInput) {
    updatePhotoRecall(photoRecallID: $photoRecallID, photoRecallInput: $photoRecallInput) {
      WidgetID
      PhotoRecallID
      PhotoRecallSize
      Configuration
      GridSize
      Layout
    }
  }
`;

export const GET_CARDHOLDERACTIVITY = gql`
  query allCardHolderActivity {
    allCardHolderActivity {
      last7Days {
        tranCode
        sourceTypeId
        transactionTypeId
        transTime
        cardHolderId
        cardNumber
        cardHolderName
      }
      last7DaysCount
    }
  }
`;

export const REQUEST_MOBILE_CREDENTIAL = gql`
  mutation requestMobileCredential($cardholderId: Int!, $phoneNumber: String) {
    requestMobileCredential(cardholderId: $cardholderId, phoneNumber: $phoneNumber) {
      id
      credentialNumber
      active
      phoneNumber
      useAdaTiming
      facilityCode
      issueCode
      activationDate
      deactivationDate
      cardFunction
      accessGroups {
        id
        name
      }
      singleReaderAccessRights {
        engageReaders {
          id
          name
          type
        }
      }
    }
  }
`;

export const RESEND_MOBILE_CREDENTIAL_TEXT = gql`
  mutation resendMobileCredentialText($id: Long!) {
    resendMobileCredentialText(id: $id)
  }
`;

export const DELETE_MOBILE_CREDENTIAL = gql`
  mutation deleteMobileCredential($id: Long!) {
    deleteMobileCredential(id: $id) {
      id
      credentialNumber
      active
      phoneNumber
      useAdaTiming
      facilityCode
      issueCode
      activationDate
      deactivationDate
      cardFunction
      accessGroups {
        id
        name
      }
      singleReaderAccessRights {
        engageReaders {
          id
          name
          type
        }
      }
    }
  }
`;

export const GET_USER_CONFIG = gql`
  query userConfigData($userconfigName: String!) {
    userConfigData(userconfigName: $userconfigName) {
      Settings
      User_ID
      User_Name
    }
  }
`;

export const GET_USER_CONFIG_ID = gql`
  query userConfigData($userconfigID: Int!) {
    userConfigData(userconfigID: $userconfigID) {
      Settings
      User_ID
      User_Name
    }
  }
`;

export const ADD_USER_CONFIG = gql`
  mutation addUserConfigValues($userConfigInput: UserConfigInput) {
    addUserConfigValues(userConfigInput: $userConfigInput) {
      Settings
    }
  }
`;

export const UPDATE_USER_CONFIG = gql`
  mutation updateUserConfig($userConfigInput: UserConfigInput) {
    updateUserConfig(userConfigInput: $userConfigInput) {
      Settings
    }
  }
`;

export const REMOVE_USER_CONFIG = gql`
  mutation removeUserConfig($userconfigID: Int!) {
    removeUserConfig(userconfigID: $userconfigID) {
      User_ID
    }
  }
`;
